import {
  OPEN_LOGIN_DIALOG,
  CLOSE_LOGIN_DIALOG
} from './login.actions';

export interface ILoginState {
  isLoginDialogOpened: boolean;
}

export const loginInitialState: ILoginState = {
  isLoginDialogOpened: false
};

export function loginReducer(state = loginInitialState, action) {
  switch (action.type) {
    case OPEN_LOGIN_DIALOG:
      return Object.assign({}, state, {isLoginDialogOpened: true});
    case CLOSE_LOGIN_DIALOG:
      return Object.assign({}, state, {isLoginDialogOpened: false});
    default:
      return state;
  }
}
